import { render, staticRenderFns } from "./PublicationSingleHeader.vue?vue&type=template&id=a62f566a&"
import script from "./PublicationSingleHeader.vue?vue&type=script&lang=js&"
export * from "./PublicationSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports